var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.792,
    height: 13.988,
    viewBox: "0 0 9.792 13.988",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-location-on",
    "data-name": "Icon material-location-on",
    d: "M12.4,3A4.892,4.892,0,0,0,7.5,7.9c0,3.672,4.9,9.092,4.9,9.092s4.9-5.42,4.9-9.092A4.892,4.892,0,0,0,12.4,3Zm0,6.644A1.749,1.749,0,1,1,14.144,7.9,1.749,1.749,0,0,1,12.4,9.644Z",
    transform: "translate(-7.5 -3)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationBlack);
export default __webpack_public_path__ + "static/media/location-black.f7427456058472c2ff3502727ed2173b.svg";
export { ForwardRef as ReactComponent };